document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook("beforeAutocompleteOptions", function (options) {
    options.openOnFocus = true;
    return options;
  });

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteConfigurationOptions",
    function (config, context) {
      if (context.sourceId !== "products") return config;

      config.queries = config.queries.map(function (query) {
        var isEmpty = !query.query || query.query.trim() === "";
        if (!isEmpty) return query;

        return Object.assign({}, query, {
          query: "",
          params: Object.assign({}, query.params, {
            hitsPerPage: 8,
            // Replace "search-featured" with whatever handle the client uses
            filters: 'collections:"best-sellers-search"',
          }),
        });
      });

      return config;
    }
  );

  // Upgrade product image quality in autocomplete results.
  // Default uses thumbnailImage (~125px) which looks soft on retina displays.
  // Swap to a larger Shopify image variant for sharper rendering.
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (template, hit) {
      function upgradeUrl(url) {
        return url ? url.replace(/_\d+x\.(jpg|jpeg|png|webp)/gi, "_600x.$1") : url;
      }
      function upgradeSrcset(srcset) {
        if (!srcset) return srcset;
        return srcset
          .replace(/_125x\./gi, "_400x.")
          .replace(/_250x\./gi, "_600x.")
          .replace(/_375x\./gi, "_800x.");
      }
      function walk(vnode) {
        if (!vnode || typeof vnode !== "object") return;
        if (vnode.type === "img" && vnode.props) {
          vnode.props.src = upgradeUrl(vnode.props.src);
          vnode.props.srcset = upgradeSrcset(vnode.props.srcset);
          // Default sizes caps the browser at 125px even when srcset has bigger
          // variants. Bump it so the browser picks the larger srcset entry.
          if (vnode.props.sizes) vnode.props.sizes = "200px";
        }
        var children = vnode.props && vnode.props.children;
        if (Array.isArray(children)) {
          children.forEach(walk);
        } else if (children) {
          walk(children);
        }
      }
      walk(template);
      return template;
    }
  );
  
});

// On mobile, Algolia's autocomplete switches to detached mode and renders an
// .aa-DetachedSearchButton, but the theme nests the search input inside a
// <details> modal that hides it — so the theme's <details> would fall back to
// Shopify's native predictive search. Listen for the <details> opening and
// immediately close it + trigger Algolia's detached overlay instead. Using the
// toggle event (instead of click) reliably prevents the theme modal from
// rendering at all, regardless of how the open was initiated.
(function () {
  var mql = window.matchMedia("(max-width: 680px)");

  document.addEventListener(
    "toggle",
    function (event) {
      if (!mql.matches) return;

      var details = event.target;
      if (!details.open) return;
      if (!details.querySelector || !details.querySelector("summary.header__icon--search")) return;

      var algoliaBtn = document.querySelector(".aa-DetachedSearchButton");
      if (!algoliaBtn) return;

      details.open = false;
      algoliaBtn.click();
    },
    true
  );
})();